import { useTheme } from '@hooks/theme';

import { lightTheme, darkTheme } from "@styles/theme"

export const useResolveColorTheme = ({
  light,
  dark,
}: {
  light: string;
  dark: string;
}): string => {
  const { theme } = useTheme();
  return theme === 'dark' ? dark : light;
};

export const isDarkTheme = () => {
  const { theme } = useTheme();
  return theme === 'dark';
};

export const currentTheme = () => {
  const { theme } = useTheme();
  return theme === 'dark' ? darkTheme : lightTheme;
};


